"use client";

import { Button } from "@/components/buttons/Button";
import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";
import { TimeResetText } from "@/components/TimeResetText";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";

export function InvalidLengthSubscriptionModal({
  open,
  closeModal,
  user,
}: {
  open: boolean;
  closeModal: () => void;
  user: UserNoDates | null;
}) {
  const setPricingModalOpen = usePricingModal((state) => state.setOpen);

  const onUpgrade = () => {
    closeModal();

    setPricingModalOpen();
  };
  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Not enough time left"
      widthMode="normal"
    >
      <div className="rounded-3xl bg-primaryLight p-4">
        <NormalText elementType="p" className="mb-4">
          Not enough time left in your subscription to convert this audio.
          Upgrade for more time.
        </NormalText>

        <TimeResetText user={user} />

        <Button
          variant="primary"
          onClick={onUpgrade}
          className="mx-auto mt-6 block"
        >
          Upgrade for more time
        </Button>
      </div>
    </Modal>
  );
}
